<template>
    <div ref="lavContainer" class="Lottie" />
</template>

<script>
import lottie from 'lottie-web';
export default {
    props: {
        options: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.anim = lottie.loadAnimation({
            container: this.$refs.lavContainer,
            renderer: 'svg',
            // loop: this.options.loop !== false,
            // autoplay: this.options.autoplay !== false,
            autoplay: false,
            animationData: this.options.animationData,
            // rendererSettings: this.options.rendererSettings,
            prerender: true
        });

        this.$emit('animCreated', this.anim);
    },
    beforeDestroy() {
        this.anim.destroy();
    }
};
</script>
